var rich_content_viewer_default = {
  "fontElementMap": "aEbdJ",
  "wrapper": "_7-Cb7",
  "pluginContainerMobile": "w-dXu",
  "viewer": "jC3Yn",
  "android": "Ujrtw",
  "rootedTraversedContent": "MveYO",
  "atomic": "wI9a7",
  "toolbar": "KBaqg",
  "block": "zUVZL"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
